import {
    LOGIN_START,
    LOGIN_SUCCESS,
    LOGIN_FAILURE
} from '../actions';

const initialState = {
    username: '',
    isFetching: false,
    error: ''
};

export const LoginReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_START: 
            return {
                ...state,
                isFetching: true,
                error: ''
            }
        case LOGIN_SUCCESS: 
            return {
                ...state,
                isFetching: false, 
                username: action.payload,
                error: ''
            }
        case LOGIN_FAILURE: 
            return {
                ...state,
                isFetching: false,
                error: action.payload
            }
        default: 
            return state;

    }
};

export default LoginReducer;